import { TypeSafeTemplateDelegate } from '../../../Utility/Handlebars/types';
import announcementContainerCompiled from './announcement-container.hbs';
import './announcement.scss';

export { defaultTemplate } from './default';
export { insufficientPlaylistRightsTemplate, videoNotSupportedTemplate } from './error';
export { videoTemplate } from './video';

export const announcementContainerTemplate: TypeSafeTemplateDelegate<null> =
    announcementContainerCompiled;
